import React, { memo } from 'react';
import { Formik, FastField } from 'formik';
import FInput from './formik/Input';
import { required } from './validators';
import { useFormRef, useFormValues } from './formik/hooks';
import Wrap from './components/FormWrap';

const initial = [{
    key: 'name',
    val: '',
    validate: required('Name')
}, {
    key: 'type',
    val: 'ibm-watson'
}, {
    key: 'clientSecret',
    val: '',
    validate: required('API Key')
}];

function IBMWatsonIntegrationForm({ onSubmit, forwardedRef, values }) {
    const ref = useFormRef(forwardedRef);
    const {vals, autoFocus, validateCb} = useFormValues(values, initial);

    return (
        <Formik
            ref={ref}
            initialValues={vals}
            validate={validateCb}
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={onSubmit}
        >
            {() => (
                <Wrap>
                    <FastField 
                        name="name" 
                        autoFocus={autoFocus}
                        label="Integration Name"
                        description="Specify integration name"
                        component={FInput} 
                    />
                    <FastField 
                        name="clientSecret" 
                        label="IBM API Key"
                        description="IBM Cloud API Key"
                        type="password"
                        component={FInput}
                        autoComplete="new-password"
                    />
                </Wrap>
            )}
        </Formik>
    )
}

export default memo(IBMWatsonIntegrationForm);